<template>
  <div class="component">
    <form ref="inputForm" @submit.prevent="computeUserInput" style="padding-bottom: 0">
      <div class="row mb-4">
        <div class="col">
          <div class="title">Aide au choix des options pour votre prévoyance complémentaire</div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <div class="row">
              <label class="col col-form-label">
                <div>Votre rémunération mensuelle brute habituelle <sup>(*)</sup></div>
                <HoverContainer>
                  <template v-slot:text>Où trouver cette information</template>
                  <template v-slot:content>
                    <img src="../assets/images/rem_brute.png" />
                  </template>
                </HoverContainer>
              </label>
              <div class="col-sm-6 col-md-5 col-lg-5">
                <input type="text" :value="formatedSalaire" class="form-control" min="0" :class="{ validationError: v$.personalInformationValues.salaireBrut.$error }" @input="updateSalaireBrut" @change="computeUserInput" required />
              </div>
            </div>
            <template v-if="displayGaranties">
              <div class="row mt-1">
                <label class="col col-form-label regular">dont primes</label>
                <div class="col-sm-6 col-md-5 col-lg-5">
                  <input type="text" :value="formatedPrimes" class="form-control regular" min="0" @input="updatePrimes" @change="computeUserInput" required />
                </div>
              </div>
            </template>
          </div>

          <template v-if="displayGaranties">
            <div class="form-group">
              <div class="row">
                <label class="col col-form-label">Nombre d'enfant(s) à charge fiscale<br />de moins de 26 ans</label>
                <div class="col-sm-7 col-md-5 col-lg-5">
                  <input type="number" class="form-control" v-model="personalInformationValues.nombreEnfantsMoins27Ans" min="0" @change="computeUserInput" required />
                </div>
              </div>
            </div>
          </template>

          <div class="form-group">
            <div class="row">
              <label class="col col-form-label">Êtes-vous ?</label>
              <div class="col-sm-6 col-md-5 col-lg-5">
                <div class="input-group flex-wrap">
                  <div class="custom-control custom-radio">
                    <input type="radio" name="radioIsContractuel" class="custom-control-input" v-model="personalInformationValues.isContractuel" :value="false" @change="computeUserInput" />
                    <label class="custom-control-label" style="white-space: nowrap">Fonctionnaire / Ouvrier d'état</label>
                  </div>
                  <div class="custom-control custom-radio">
                    <input type="radio" name="radioIsContractuel" class="custom-control-input" v-model="personalInformationValues.isContractuel" :value="true" @change="computeUserInput" />
                    <label class="custom-control-label">Contractuel</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col visible-xs">
          <div class="form-group">
            <div class="row">
              <div class="col">
                <p>Les résultats présentés sont basés sur les informations fournies. Ils sont donnés uniquement <strong>à titre indicatif</strong> et n'ont pas de valeur contractuelle.</p>
                <p>Les données renseignées dans le simulateur ne seront pas enregistrées, elles servent uniquement à vous faire une simulation, pour plus d'informations, veuillez consulter <a href="NOTICE-INFORMATIVE-RGPD-VIVINTER-Fonction-publique_Octobre25-1.pdf" target="_blank">la notice RGPD MinFi</a>.</p>
                <p>
                  <sup>(*)</sup> : Hors primes ponctuelles, primes et indemnités dont les montants tiennent compte de la manière de servir de l’agent et/ou de l’atteinte de résultats (ex. : Bonus annuel, CIA : Complément Indemnitaire Annuel), primes qui rétribuent des évènements particulières (ex : primes liées à la mobilité -PRS : Prime de restructuration de service), primes qui sont représentatives de frais ou qui sont liées au remboursement des frais de transport entre le domicile et le travail, primes et indemnités qui sont liées à l’organisation du temps de travail et qui sont versées après un service effectif (astreintes, heures supplémentaires, majoration travail de nuit, forfait télétravail…), primes et indemnités qui constituent la rémunération d’une activité accessoire (par exemple au titre de l’animation de formations, jury), hors Supplément Familial de Traitement (SFT) et hors Indemnité de Résidence (IR). <br />
                  En complément, pour les agents qui sont en poste dans l’un des territoires suivants : Nouvelle-Calédonie, Wallis et Futuna, Polynésie française, Saint-Pierre-et-Miquelon : l’indexation doit également être retirée de la rémunération prise en compte.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col hidden-xs" style="padding: 0 1.5rem; text-align: justify">
          <p>Les résultats présentés sont basés sur les informations fournies. Ils sont donnés uniquement <strong>à titre indicatif</strong> et n'ont pas de valeur contractuelle.</p>
          <p>Les données renseignées dans le simulateur ne seront pas enregistrées, elles servent uniquement à vous faire une simulation, pour plus d'informations, veuillez consulter <a href="NOTICE-INFORMATIVE-RGPD-VIVINTER-Fonction-publique_Octobre25-1.pdf" target="_blank">la notice RGPD MinFi</a>.</p>
          <p>
            <sup>(*)</sup> : Hors primes ponctuelles, primes et indemnités dont les montants tiennent compte de la manière de servir de l’agent et/ou de l’atteinte de résultats (ex. : Bonus annuel, CIA : Complément Indemnitaire Annuel), primes qui rétribuent des évènements particulières (ex : primes liées à la mobilité -PRS : Prime de restructuration de service), primes qui sont représentatives de frais ou qui sont liées au remboursement des frais de transport entre le domicile et le travail, primes et indemnités qui sont liées à l’organisation du temps de travail et qui sont versées après un service effectif (astreintes, heures supplémentaires, majoration travail de nuit, forfait télétravail…), primes et indemnités qui constituent la rémunération d’une activité accessoire (par exemple au titre de l’animation de formations, jury), hors Supplément Familial de Traitement (SFT) et hors Indemnité de Résidence (IR).<br />
            En complément, pour les agents qui sont en poste dans l’un des territoires suivants : Nouvelle-Calédonie, Wallis et Futuna, Polynésie française, Saint-Pierre-et-Miquelon : l’indexation doit également être retirée de la rémunération prise en compte.
          </p>
        </div>
      </div>
    </form>

    <div class="row justify-content-end mt-3">
      <div class="col-sm-6 col-md-6 col-lg-5">
        <div class="button-container">
          <template v-if="displayGaranties">
            <Transition enter-active-class="animate__animated animate__fadeIn" leave-active-class="animate__animated animate__fadeOut">
              <button class="btn btn-primary hidden-print" @click="print" v-if="showPrintButton">
                <img src="@/assets/images/imprimante.svg" width="32" />
              </button>
            </Transition>
          </template>
          <button type="submit" class="btn btn-primary" @click="computeUserInput(event, true)">
            Lancer la simulation
            <img src="@/assets/images/fleche_droite.svg" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { minValue, required } from "@vuelidate/validators";
import objectHelper from "@/classes/helpers/objectHelper";
import UserInformations from "@/classes/dto/userInformations";
import HoverContainer from "./HoverContainer.vue";

const greaterThanZero = (value) => value > 0;

export default {
  name: "UserInputForm",
  emits: ["compute", "print"],
  components: { HoverContainer },
  props: {
    displayGaranties: {
      type: Boolean,
    },
  },
  data() {
    return {
      objectHelper,
      personalInformationValues: new UserInformations(),
      buttonComputeClickedAtLeastOneTime: false,
      showPrintButton: false,
      showTrancheAgeTooltip: false,
    };
  },
  setup: () => {
    return { v$: useVuelidate() };
  },
  created() {},
  validations() {
    return {
      personalInformationValues: {
        salaireBrut: { required, greaterThanZero },
        primes: { required, minValue: minValue(0) },
      },
    };
  },
  mounted() {
    if (window.location.hostname == "localhost") {
      setTimeout(() => {
        this.buttonComputeClickedAtLeastOneTime = true;
        this.computeUserInput();
      }, 1000);
    }
  },
  computed: {
    formatedSalaire() {
      return this.personalInformationValues.salaireBrut.toLocaleString("fr-FR", {
        style: "currency",
        currency: "EUR",
        minimumFractionDigits: 0,
      });
    },
    formatedPrimes() {
      return this.personalInformationValues.primes.toLocaleString("fr-FR", {
        style: "currency",
        currency: "EUR",
        minimumFractionDigits: 0,
      });
    },
  },
  methods: {
    print() {
      this.$emit("print");
    },
    updateSalaireBrut(event) {
      const value = event.target.value.replace(/[^\d]/g, "");
      this.personalInformationValues.salaireBrut = parseFloat(value) || 0;
    },
    updatePrimes(event) {
      const value = event.target.value.replace(/[^\d]/g, "");
      this.personalInformationValues.primes = parseFloat(value) || 0;
    },
    async computeUserInput(event, buttonWasClicked = false) {
      if (buttonWasClicked) {
        this.buttonComputeClickedAtLeastOneTime = true;
      }

      if (this.buttonComputeClickedAtLeastOneTime && (await this.v$.$validate()) === true) {
        this.$emit("compute", this.personalInformationValues);
        this.showPrintButton = true;
      }
    },
    manageTooltip() {},
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/_variables.scss";

.component {
  $sideMargin: 5rem;

  form {
    padding: 1.5rem 0;
    margin: 0 $sideMargin;
    border-radius: 5px;
    color: $secondary;
    background-color: white;

    @media (max-width: $screen-md-max) {
      padding: 0.5rem 0;
    }

    .title {
      font: normal normal normal 26px/38px "csb";
      text-align: center;

      @media (max-width: $screen-md-max) {
        padding: 0 1rem;
        margin-top: 0.5rem;
        line-height: 30px;
      }
    }

    .form-group {
      padding: 0 $sideMargin;
    }
  }

  @media (max-width: $screen-md-max) {
    $sideMargin: 1rem;

    form {
      margin: 0 $sideMargin;

      .form-group {
        padding: 0 $sideMargin;
      }
    }
  }

  .button-container {
    margin: 0;
    margin-right: 5rem;
    display: flex;

    @media (max-width: $screen-md-max) {
      $sideMargin: 1rem;
      margin: 0 $sideMargin;
    }

    button {
      $size: 48px;
      height: $size;
      text-align: left;
      width: $size;

      &:not(.hidden-print) {
        width: 100% !important;

        &.btn-primary {
          font: normal normal normal 16px/22px "csb";
          letter-spacing: 0px;
          color: white;
          border-color: white;
          background-color: transparent;
        }

        img {
          float: right;
        }
      }

      &.hidden-print {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 0.5rem;
        border-color: white;
        background-color: transparent;

        img {
          $ratio: 0.7;
          max-width: calc($size * $ratio);
          max-height: calc($size * $ratio);
        }
      }
    }
  }
}
</style>
